<template>
  <Teleport to="body">
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="translate-y-[-1rem] opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-[-1rem] opacity-0"
    >
      <div v-if="invite"
           class="fixed top-4 right-4 z-[100] w-80 rounded-xl bg-white shadow-2xl border border-gray-200 overflow-hidden">

        <!-- Pulsing accent bar -->
        <div class="h-1 bg-gradient-to-r from-blue-500 to-blue-600 animate-pulse" />

        <div class="p-4">
          <div class="flex items-center gap-3">
            <div class="w-11 h-11 rounded-full bg-blue-500 flex items-center justify-center shrink-0">
              <VideoCameraIcon class="w-5 h-5 text-white" />
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-gray-900 truncate">{{ invite.inviter_name }}</p>
              <p class="text-xs text-gray-500">
                {{ invite.type === 'direct' ? 'Video Call' : invite.title || 'Meeting Invite' }}
              </p>
            </div>
          </div>

          <div class="mt-3 flex gap-2">
            <button @click="decline"
                    class="flex-1 px-3 py-2 text-sm rounded-lg border border-red-200 text-red-600 hover:bg-red-50 font-medium transition-colors">
              Decline
            </button>
            <button @click="accept"
                    class="flex-1 px-3 py-2 text-sm rounded-lg bg-blue-500 text-white hover:bg-blue-600 font-medium transition-colors">
              Accept
            </button>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import { computed, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { VideoCameraIcon } from '@heroicons/vue/24/solid'

const store = useStore()

const invite = computed(() => store.state.meetings.incomingInvite)

let ringtoneAudio = null

function startRingtone() {
  try {
    if (!ringtoneAudio) {
      ringtoneAudio = new Audio('/assets/sounds/video-ring.wav')
      ringtoneAudio.loop = true
      ringtoneAudio.volume = 0.7
    }
    ringtoneAudio.currentTime = 0
    ringtoneAudio.play().catch(() => {})
  } catch {}
}

function stopRingtone() {
  if (ringtoneAudio) {
    ringtoneAudio.pause()
    ringtoneAudio.currentTime = 0
  }
}

watch(invite, (val) => {
  if (val) startRingtone()
  else stopRingtone()
}, { immediate: true })

onBeforeUnmount(() => stopRingtone())

async function accept() {
  stopRingtone()
  try {
    await store.dispatch('meetings/acceptInvite')
    const meetingId = store.state.meetings.activeCall.meetingId
    if (meetingId) {
      const url = `/communications/meet/room/${meetingId}`
      const w = 1200, h = 800
      const left = Math.round((screen.width - w) / 2)
      const top = Math.round((screen.height - h) / 2)
      window.open(url, `meeting_${meetingId}`, `width=${w},height=${h},left=${left},top=${top}`)
    }
  } catch (e) {
    console.error('Failed to accept video invite:', e)
    store.dispatch('meetings/dismissInvite')
  }
}

function decline() {
  stopRingtone()
  store.dispatch('meetings/dismissInvite')
}
</script>
